import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('plant/index', {params});
    },
    getPlant(params) {
        return Service().get('plant/get-plant', {params});
    },
    show(id) {
        return Service().get('plant/show/'+id);
    },
    create(params) {
        return Service().post('plant/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('plant/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('plant/delete/'+id);
    },
}